var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"bg-image-login"},[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('snackbar-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }